import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'autoSlotFilter'
})
export class AutoSlotFilterPipe implements PipeTransform {

  transform(slots: any[], idShifts: string[]): any[] {
    
    if (!idShifts[0]) return slots

    let returnSlots = slots.filter(s => idShifts.includes(s.idShift)).sort(function (a, b) { if (a.start < b.start) return -1; if (a.start > b.start) return 1; return 0; });
    
    //console.log(returnSlots)

    return returnSlots

  }

}
